module.exports = __webpack_public_path__ + "static/media/logo.807fd623.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 69
// module chunks = 0